import { useContext, useRef } from 'react';

import { ConfirmationDialog } from './ConfirmationDialog';
import { DrawerContext } from './DrawerContext';
import type { DrawerConfirmationOptions } from './layerStoreReducer';

interface DrawerConfirmationProps {
    layerId: number;
    confirmation: DrawerConfirmationOptions;
}

export const DrawerConfirmation = ({ layerId, confirmation }: DrawerConfirmationProps) => {
    const { resolveConfirmation } = useContext(DrawerContext);
    const previousFocus = useRef(document.activeElement);

    return (
        <ConfirmationDialog
            confirmation={confirmation}
            onKeepEditing={() => resolveConfirmation(layerId, false)}
            onConfirm={() => resolveConfirmation(layerId, true)}
            restoreFocus={() => {
                window.setTimeout(() => {
                    const target = previousFocus.current;
                    if (
                        target instanceof HTMLElement &&
                        target.isConnected &&
                        !target.closest('[inert]') &&
                        !target.matches(':disabled')
                    ) {
                        target.focus();
                        return;
                    }
                    const layer = document.querySelector<HTMLElement>(`[aria-labelledby="drawer-title-${layerId}"]`);
                    const fallback = layer?.querySelector<HTMLElement>('button:not(:disabled)');
                    (fallback ?? layer)?.focus();
                }, 0);
            }}
        />
    );
};
